// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1B0PJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__3SPyE"};